<!-- Main Content -->
    <main>
      <div class="container">
        <div class="main_content">
          <!-- Aside -->
          <!-- Breadcrumb -->
          <div class="breadcrumb">
            <ul>
              <li>
                <a href="tour?loc=9999">旅行團 </a>
              </li>
              <li *ngIf="location!=9999&&catContent!='any'&&title=='any'&&(catType=='top'||catType=='sub')">{{ this.catContent.replaceAll("\<br\>","") }}</li>
              <li *ngIf="location==9999||title!='any'">{{ title.replaceAll("\<br\>","/") }}</li>
            </ul>
          </div>
          <!-- Feed Devider -->
          <div class="main_content_feed">

            <div class="aside_area">

              <div class="as_ct_search">
                <input
                  type="search"
                  id="searchTour"
                  placeholder="搜索國家/地區/地方/關鍵詞/團號"
                  value=""
                  (keyup.enter)="searchTour()"
                />
                <button type="button" (click)="searchTour()">
                  <i class="fas fa-search">搜尋</i>
                </button>
              </div>  
  
              <!-- aside main content -->
              <div class="aside_area_head">
                <div class="aside_header">
                  <div class="aside_header_bar">
                    <small>☰</small>
                    <span (click)="showMobileMenu()">全部目的地</span>
                  </div>
                  <!-- aside header menu -->
                  <div
                  class="aside_header_menu"
                  style="display: block; position: inherit" >
                  <ul  >
                    <li class="as_menu_item" id="as_menu" *ngFor="let data of categoryList " >
                      <span *ngIf="storeParentId(data)" > {{ data.parentName }}</span>
                      <div class="as_sub_menu" id="as_sub_menu">
                        <h3 class="as_sub_menu_title" ><a href="tour?loc={{data.categoryId}}&type=top&title=全部{{data.parentName}}">全部{{ data.parentName}}</a></h3>
                        <ul >
                          <li *ngFor="let dataSub of filterListSub  ">
                            <a href="/tour?loc={{ dataSub.categoryId}}&type=sub" [innerHTML]="dataSub.categoryName"></a>
                          </li>
                        </ul>
                      </div>
                    </li>
                    
                  </ul>
                  
                </div>

                </div>
              </div>



            </div>
            <!-- Feed -->
            <div class="feed_area">
              <div class="feed_header">
                <h4>已搜尋{{this.totalTour}}個團</h4>
                <span>旅行查詢熱線:3850-7200</span>
              </div>

              <div *ngIf="this.totalTour ==0" style="font-size:24px; text-align:center;margin-bottom:30px;margin-top:30px">
                  即將推出！
              </div>
              <!-- feed area content -->
                 <!-- single feed content -->
              <div *ngFor="let data of TourList ">
                <div class="single_feed_card" >
                  <div class="single_feed_card_content">
                    <div class="feed_card_thumb" >
                        <img *ngIf="data.imageName" style="width:100%" src="assets/img/tour/{{ data.tourCode }}/{{ data.imageName}}" alt="thumb" (click)="loadItineraryPage(data.tourCode)" />
                        <img *ngIf="!data.imageName" style="width:100%" src="assets/img/tour/blank_img01.jpg" alt="thumb" (click)="loadItineraryPage(data.tourCode)" />
                    </div>
                    <div class="feed_card_text">
                      <h3 [innerHTML]="data.tourName">
                      </h3>
                      <p class="toursID">
                        <span>{{ data.tourCode}} (</span>
                        <a _blank (click)="openPDF(data.brochureLink,'T')">下載行程</a>
                        <span>)</span>
                      </p>
                      <p class="startDate" style="border:solid;border-width:thin;padding:5px; border-radius: 1ch;" >
                        <span style="font-weight: 400">出發日期：</span>
                        <span style="display:block; column-count:3">
                          <span *ngFor="let departDate of data.departureDateFrom.split(','); let cnt = index" >
                            <span *ngIf="cnt<20">{{ departDate}}</span>
                            <span *ngIf="cnt == 20" (click)="loadItineraryPage(data.tourCode)" style="cursor:pointer;"><u>更多</u></span>
                          </span>
                        </span>
                      </p>
                      <p class="daynum">
                        天數：<span
                          id="ctl00_ContentPlaceHolder1_RepeaterHotSellTour_ctl02_Label_Day"
                          >{{data.tourDays}}</span
                        >天
                      </p>

                      <!-- ...existing code... -->
                      <div style="display:flex">
                        <div *ngFor="let discount of discountFilter(data.tourCode)" >
                          <p *ngIf="discount.discountCode == 'B'" class="discountStyle1">同行優惠</p>
                          <p *ngIf="discount.discountCode == 'S'" class="discountStyle2">長者優惠</p>
                        </div>
                      </div>

                      <!-- ...existing code... -->

                      <div style="display:flex">
                        <p class="priceStyle"> HK{{data.tourPrice|currency: 'HKD': 'symbol-narrow': '0.0'}}+/位</p>
                        <div  *ngIf="data.selfpaidpdf!=''" style="display:flex">
                          <div *ngFor="let selfpaid of data.selfpaidpdf.split(',')" >
                            <p class="selfPaidStyle" ><a target="_blank" (click)="openPDF(selfpaid,'S')" style="cursor:pointer">自費節目表<br>({{selfpaid.split('自費節目表')[0]}})</a></p>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                    <!-- Feed action -->
                    <div class="feed_card_action">
                      <div class="feed_action_head">
                        <i class="fas fa-users"></i>
                      </div>
                      <div class="feed_action_socail">
                        <ul>
                          <li class="socailArea_tg">
                            <a href="https://api.whatsapp.com/send/?phone=85238507222&text=你好，團號：{{data.tourCode}}，想詢問有關資料。&type=phone_number&app_absent=0" target="_blank">
                              <img
                                src="assets/img/whatsapp.png"
                                alt="whatsapp"
                              />
                            </a>
                          </li>
                         
                          <li class="buyArea_tg">
                            <button
                              type="button"
                              class="buy_btn"
                              data-show-cl-in="rand_cl-3"
                              (click)="loadItineraryPage(data.tourCode)"
                            >
                              選擇出發日期
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                   
                  </div>
                  <!-- Departure Calendar -->
                  
                  <div class="departure_calender" id="rand_cl-3">
                    <!-- Alifur here -->

                  </div>
                  
                </div>
                <!-- Feed Card Devider -->
                <div class="feed_card_devider"></div>
                <!-- single feed content -->
              </div>  
              <!-- pagination -->
<!--              <div class="pagination">
                <a href="#" class="prev">Prev</a>
                <ul class="page-list">
                  <li><a href="#" class="active">1</a></li>
                  <li><a href="#">2</a></li>
                  <li><a href="#">3</a></li>
                  <li><a href="#">4</a></li>
                  <li><a href="#">5</a></li>
                </ul>
                <a href="#" class="next">Next</a>
              </div>
            -->
            </div>
            </div>
          </div>
        </div>
    </main>
    <div id="calendar"></div>





    <!-- Script Here -->
    <script src="assets/js/script.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/fullcalendar@6.1.9/index.global.min.js"></script>

    <script src="https://cdn.jsdelivr.net/npm/@fullcalendar/core@6.1.9/locales-all.global.min.js"></script>
    <script src="assets/js/init-event-calender.js"></script>
    <script>
      // Parent aside menu
      var headerBar = document.querySelector(".aside_header_bar");
      var headerMenu = document.querySelector(".aside_header_menu");

      headerBar.addEventListener("click", function () {
        headerBar.classList.toggle("active");
        headerMenu.style.display = headerBar.classList.contains("active")
          ? "block"
          : "none";

        var icon = headerBar.querySelector("small");
        if (icon) {
          if (icon.innerHTML === "☰") {
            icon.innerHTML = "✕";
          } else {
            icon.innerHTML = "☰";
          }
        }
      });
    </script>
